import https from "@/lib/https";
import type {
  DepartmentDetail,
  DepartmentPayload,
  GetDepartmentListParams,
} from "@/interface/masterManagement";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/master/departments/";

export const getDepartmentList = async (
  params: GetDepartmentListParams,
): Promise<ApiResponse<PaginationResponse<DepartmentDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<DepartmentDetail>>>(
    BASE_URL,
    params,
  );
};

export const createDepartment = async (
  payload: DepartmentPayload,
): Promise<ApiResponse<DepartmentDetail>> => {
  return await https.post<ApiResponse<DepartmentDetail>>(BASE_URL, payload);
};

export const updateDepartment = async (
  id: number | string,
  payload: DepartmentPayload,
): Promise<ApiResponse<DepartmentDetail>> => {
  return await https.put<ApiResponse<DepartmentDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteDepartment = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
